import { z } from "zod";

const terms = z.object({
  milestoneLabel: z
    .string()
    .min(1, "A brief description of the milestone is required"),
  totalAmountCents: z
    .number()
    .int()
    .min(1, { message: "A milestone payment is required" })
    .nullable()
    .refine((v) => v !== null, { message: "A milestone payment is required" }),
});

const schema = z.object({
  terms: z.array(terms).min(1),
  note: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export { schema as milestoneOfferForm, type Schema as MilestoneOfferForm };
